module.exports = __webpack_public_path__ + "img/HA2515-67.d959313b.jpg";